import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { IObjectViewModel } from '@/engine/app/interfaces';
import type { ViewsService } from '@/engine/app/Views.service';
import { AddCommissureCommand } from './AddCommissure.command';
import type * as THREE from 'three';
import { InvertCommandDecorator } from '@/engine/app/modules/core/commands/Invert.command';
import type { ICommissureCommandsFactory } from '../interfaces';
import type { ITTVRObjectsAlgoHelper } from '@/surgeries/cardiac/TTVR/interfaces';

@injectable()
export class CommissureCommandsFactory implements ICommissureCommandsFactory {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _viewsService: ViewsService;

  public constructor(
    @inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm,
    @inject(TYPES.ViewsService) viewsService: ViewsService
  ) {
    this._planningAlgorithm = planningAlgorithm;
    this._viewsService = viewsService;
  }

  public createAddCommissureCommand(
    view: ViewEntity,
    vector: THREE.Vector3,
    viewModel: IObjectViewModel,
    vectorDescriptor: string,
    algoHelper: ITTVRObjectsAlgoHelper
  ): ICommand {
    return new AddCommissureCommand(
      view,
      vector,
      vectorDescriptor,
      viewModel,
      this._viewsService,
      this._planningAlgorithm,
      algoHelper
    );
  }

  public createRemoveCommissureCommand(
    view: ViewEntity,
    vector: THREE.Vector3,
    viewModel: IObjectViewModel,
    vectorDescriptor: string,
    algoHelper: ITTVRObjectsAlgoHelper
  ): ICommand {
    const addCommand = this.createAddCommissureCommand(view, vector, viewModel, vectorDescriptor, algoHelper);
    return new InvertCommandDecorator(addCommand);
  }
}
